module.exports = __webpack_public_path__ + "img/08@2x.0fb70acb.png";